// import PropTypes from 'prop-types'
import propType from './DefaultPropTypes'

export default {
  ...propType,
}
